export const SET_SORT_BY = 'SET_SORT_BY';
export const setSortBy = (sortBy) => {
  return {
    type: SET_SORT_BY,
    sortBy,
  };
};